export const setCUSTOMERPERSONS = "setCUSTOMERPERSONS";